<template>
  <main-layout>
    <h1 class="title">Crea prodotto</h1>
    <product-type-form
      :submit-action="create"
      :fields="fields"
      redirect-route="productTypes.show"
    />
  </main-layout>
</template>

<script>
import { call } from "vuex-pathify"

import ProductTypeForm from "@/components/ProductTypeForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    ProductTypeForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    create: call("productTypes/create")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
